import { map } from 'rxjs/operators';
import { ofType } from 'redux-observable';
// ---- external imports ----

import { loadingActions } from '~/store';
import { TURN_FETCHING_NEXT } from '~/store/turn/actionTypes';
import { turnSelectors } from '../../selectors';
import { TURN_UPDATE_SAVE_CHECKPOINT_AFTER_FETCH } from '~/store/turn/actionTypes';
// ---- internal imports ----


const nextTurnLoadingEpic = (action$) => action$.pipe(
	ofType(TURN_FETCHING_NEXT),
	map((action) =>
		action.isNextTurnLoading
			? start()
			: end()
	)
);

function start(){
	return async (dispatch, getState) => {
		dispatch(loadingActions.start(TURN_FETCHING_NEXT));
	};
}

function end(){
	return async (dispatch, getState) => {
		dispatch(loadingActions.end(TURN_FETCHING_NEXT));

		const shallSaveCheckpointAfterTurnLoaded = turnSelectors.getSaveCheckpointAfterTurnLoaded(getState());
		if (shallSaveCheckpointAfterTurnLoaded) {
			//	reset saving checkpoint flag
			console.log("resetting shallSaveCheckpointAfterTurnLoaded")
			dispatch({ type: TURN_UPDATE_SAVE_CHECKPOINT_AFTER_FETCH, save: false });
		}

	};
}

export default nextTurnLoadingEpic;
